export default __webpack_public_path__ + "static/media/contact.3666ba70.svg";